<template>
  <footer>
    <div class="footer-container">
        <div class="logo-header"> <img class="home-logo" src="../assets/ico-white.svg">
            <div class="logo-text">
                Archivo Fotografía Urbana
            </div>
        </div>
        <p class="footer-text">Caracas, Venezuela. <br>
            Telf: +58 212 9915256
        </p>
        <div class="social-buttons">
           <a href="https://www.facebook.com/fotourbanaorg"> <i class="fab fa-facebook-square"></i></a>
           <a href="https://www.instagram.com/fotourbanaorg/"> <i class="fab fa-instagram"></i></a>
           <a href="https://twitter.com/fotourbanaorg"> <i class="fab fa-twitter"></i></a>
           <a href="https://www.youtube.com/channel/UCGPn3PDaWP5Z8tNaUWAo1PA"> <i class="fab fa-youtube"></i></a>
        </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'FotoFooter',
  props: {
    title: String,
  }
}
</script>
<style>
footer {
    padding-top: 20px;
    padding-bottom: 20px;
    height: 120px;
    background-color: #F4BC0B;
    display: flex;
    justify-content: center;
}
.footer-container{
    width: 1280px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    alig-items: middle;
}
.footer-text{
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-family: Raleway;
}
.social-buttons {
    padding-top: 20px;
    padding-right: 40px;
}
.fab {
    color: #000000;
    font-size: 30px;
    padding-left: 5px;
    opacity: 1;
    transition: all 0.3s ease-in-out;
}
.fab:hover {
    color: #000000;
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
}
.logo-text {
    width: 110px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding-left: 10px;
    padding-top: 2px;
    text-align: left;
}
.logo-header {
    display: flex;
    flex-direction: row;
}
@media only screen and (max-width:1255px){
    .img-aliados{
        height: 120px;
        padding: 10px;
    }
}


@media only screen and (max-width: 1150px){

    .menu{
        display: none;
    }
    .res-menu{
        display: inline !important;
        font-size: 30px;
        padding-top: 10px;
        cursor: pointer;
    }

}

@media only screen and (max-width: 640px){

    .logo-text {
        width: 62px;
        font-family: Raleway;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding-left: 9px;
        padding-top: 11px;
    }

    .search {
        width: 160px;
    }

    .title-about{
        width: 100%;
        font-size: 25px;
    }

    .about-afu{
        width: 100%;
        height: 380px;
    }
    .card-post{
        height: auto;
    }
    .img-gradient, .card-post-img-2{
        height: 180px;
    }


    .yellow{
        width: 100% !important;
    }
    .home-slider{
        width: 100%;
        height: auto;
    }
    .slideshow-container {
        height: auto !important;
    }
    .img-aliados{
        height: 90px;
        padding: 1px;
    }
    .footer-container{
        padding-left: 40px;
        flex-direction: column;
    }
    footer{
        height: auto;
    }
}
</style>
